var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuePhoneNumberInput',{class:{
                    'bg-red-100 border-red-700 OnErrorScrollHere': false
                  },attrs:{"color":"#63b3ed","valid-color":"#63b3ed","error-color":"#63b3ed","default-country-code":"PY","translations":_vm.translations,"no-example":true,"show-code-on-list":true},on:{"update":_vm.onInput},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }